import api from "./index";

// RxTemplate Service
export const RxTemplateService = {
  // Create RxTemplate
  createRxTemplate: async (data: {
    prescriptionName: string;
    medication: string[];
    notes: string;
    description?: string | null;
    duration?: string | null;
    dosage?: string | null;
  }) => {
    return api.post("/rxtemplate/create", data);
  },

  // Get All RxTemplates with Pagination
  getRxTemplates: async (paginationData: {
    curPage: number;
    perPage: number;
    sortBy: string;
    direction: string;
    whereClause?: Array<{
      key: string;
      value: string;
      operator: string;
    }>;
  }) => {
    return api.post("/rxtemplate/pagination", paginationData);
  },

  // Get Single RxTemplate by ID
  getRxTemplateById: async (id: string) => {
    return api.get(`/rxtemplate/getById/${id}`);
  },

  // Update RxTemplate
  updateRxTemplate: async (id: string, data: {
    prescriptionName: string;
    medication: string[];
    notes: string;
    description?: string | null;
    duration?: string | null;
    dosage?: string | null;
  }) => {
    return api.post(`/rxtemplate/update/${id}`, data);
  },

  // Remove RxTemplate
  removeRxTemplate: async (id: string) => {
    return api.get(`/rxtemplate/remove/${id}`);
  },
};

export default RxTemplateService;
